module.exports = __webpack_public_path__ + "img/NoiseAware_AppleAppStore.998316bc.png";